import React, { useState } from 'react';
import { ExamChargesModuleContextProvider } from './context';
import ExamChargesDetails from './examChargesDetails';
import ExamChargesCollection from './examChargesCollection';

const StudentExamCharges = () => {

    const [onPaymentCollectionStep, setOnPaymentCollectionStep] = useState(false);

    return (
        <ExamChargesModuleContextProvider setOnPaymentCollectionStep={setOnPaymentCollectionStep}>
            <div className='p-3'>
                {
                    onPaymentCollectionStep
                        ? <ExamChargesCollection />
                        : <ExamChargesDetails />
                }
            </div>
        </ExamChargesModuleContextProvider>

    )
}

export default StudentExamCharges;